/**
 * Translate old rules model to new model
 *
 * Translates legacy rule format to new format by:
 * - Converting `delay` to `displayDelay`
 * - Setting `openDelay` to 0 if `proactive` was true
 * - Removing deprecated `delay` and `proactive` properties
 */

export interface LegacyRule {
  delay?: number;
  displayDelay?: number;
  openDelay?: number;
  proactive?: boolean;
  type?: string;
  message?: string;
  [key: string]: unknown;
}

export interface TranslatedRule {
  displayDelay: number;
  openDelay?: number;
  type?: string;
  message?: string;
  [key: string]: unknown;
}

export type Rules = Record<string, LegacyRule | TranslatedRule>;

export default function translateRules(rules: Rules | undefined | null): Rules {
  if (!rules) {
    return {};
  }

  const translated: Rules = { ...rules };

  for (const key in translated) {
    const rule = translated[key];
    if (!rule) {
      continue;
    }

    // Identify old model by presence of rule.delay
    if ('delay' in rule && rule.delay !== undefined && typeof rule.delay === 'number') {
      rule.displayDelay = rule.delay;
      if ('proactive' in rule && rule.proactive) {
        rule.openDelay = 0;
      }
    } else if (!('displayDelay' in rule) && !('delay' in rule)) {
      rule.displayDelay = 0;
    }

    // Remove deprecated properties
    // TypeScript doesn't know these properties exist, but we check for them above
    if ('delay' in rule) {
      delete rule.delay;
    }
    if ('proactive' in rule) {
      delete rule.proactive;
    }
  }

  return translated;
}
